export const BUSINESS = {
  name: "Diamond's Divine Arts",
  artist: "Natalia",
  email: "diamondsdivinearts@gmail.com",
  phone: "203-434-9307",
  phoneHref: "tel:+12034349307",
  instagram: "@diamondsdivinearts",
  instagramUrl: "https://www.instagram.com/diamondsdivinearts",
  tagline: "Faith • Creativity • Purpose",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact", label: "Contact" },
];

export const FOOTER_LINKS = [
  ...NAV_LINKS.slice(0, 6),
  { to: "/booking", label: "Book" },
  { to: "/contact", label: "Contact" },
];

export const MARQUEE_ITEMS = [
  "Biblical Storytelling",
  "Original Paintings",
  "Custom Sacred Commissions",
  "Faith & Creativity",
  "Excellence in Artistry",
  "Divine Inspiration",
];

export const CATEGORIES = ["All Works"];

export const ARTWORKS = [
  {
    id: 10,
    title: "The Anointed Pour",
    category: "Original Artwork",
    featured: true,
    description:
      "An original painting by Natalia — a vessel pours a stream of gold over a resting figure among the clouds, finished with hand-applied gold leaf.",
    medium: "Oil & Gold Leaf on Canvas",
    dimensions: "On request",
    year: "—",
    price: "$1,850",
    seed: 1,
    aspect: "aspect-[4/5]",
    images: ["/assets/anointed-pour-1.webp", "/assets/anointed-pour-2.webp"],
    purchaseKey: "anointedPour",
  },
];

export const SERVICES = [
  {
    number: "01",
    title: "Original Artwork",
    short: "One-of-a-kind gallery originals created through prayerful studio practice.",
    description:
      "Unique original pieces inspired by biblical themes and faith — each one painted slowly, prayerfully, and never repeated.",
    features: ["Certificate of Authenticity", "Gallery-Wrapped Canvas", "Worldwide Shipping"],
  },
  {
    number: "02",
    title: "Custom / Commissioned Artwork",
    short: "Bespoke paintings tailored to your testimony, home, or ministry space.",
    description:
      "Share your story, a scripture that anchors you, or a space that needs life — Natalia will develop a personalized piece with you from concept to canvas.",
    features: ["Personalized Concept Sketches", "Scripture Integration", "Progress Updates"],
  },
  {
    number: "03",
    title: "One-on-One Art Consultations",
    short: "A private session to discuss artwork, commissions, or creative projects.",
    description:
      "A one-on-one conversation with Natalia to explore ideas, review your space, discuss a commission, or plan a creative collaboration — no obligation.",
    features: ["Space & Palette Discussion", "Concept Framing", "In-Depth Q&A"],
  },
  {
    number: "04",
    title: "Prints & Artwork Products",
    short: "Museum-grade prints designed to bring faith into everyday spaces.",
    description:
      "Archival-quality prints of selected originals, produced to museum standards — an accessible way to bring faith-inspired art into your home.",
    features: ["Archival Cotton Paper", "Numbered Limited Editions", "Custom Framing Available"],
  },
];

export const PRICING = [
  {
    title: "Prints",
    price: "Starting at $20",
    unit: "per print",
    description: "Museum-grade archival giclée prints on textured cotton paper.",
    features: ["Numbered limited editions", "Multiple sizes", "Framing available"],
    cta: { label: "Explore Prints", to: "/portfolio" },
    testid: "pricing-prints",
  },
  {
    title: "Original Pieces",
    price: "Starting at $850",
    unit: "per artwork",
    description: "Unique original paintings on gallery canvas with gold accents.",
    features: ["Certificate of authenticity", "One-of-one pieces", "Worldwide shipping"],
    cta: { label: "View Originals", to: "/portfolio" },
    testid: "pricing-originals",
  },
  {
    title: "Custom Artwork",
    price: "Starting at $200",
    unit: "per commission",
    description: "Bespoke sacred paintings developed collaboratively with Natalia.",
    features: ["Concept sketches included", "Scripture integration", "Milestone updates"],
    cta: { label: "Request a Custom Piece", to: "/booking" },
    testid: "pricing-custom",
  },
  {
    title: "One-on-One Consultation",
    price: "$45",
    unit: "per session",
    description: "A private 45-minute session to discuss your vision, space, or project.",
    features: ["45-minute session", "Virtual or in person", "Credited toward commissions"],
    cta: { label: "Book One-on-One Consultation — $45", to: "/booking" },
    testid: "pricing-consultation",
  },
];

export const TIME_SLOTS = [
  "9:00 AM",
  "10:30 AM",
  "12:00 PM",
  "1:30 PM",
  "3:00 PM",
  "4:30 PM",
  "6:00 PM",
];

export const BOOKING_SERVICES = [
  {
    id: "consultation",
    name: "One-on-One Consultation",
    detail: "A private 45-minute session with Natalia",
    deposit: "$45 session fee",
    depositAmount: "$45",
  },
  {
    id: "commission",
    name: "Custom / Commissioned Artwork",
    detail: "Begin a bespoke sacred piece",
    deposit: "$100 deposit",
    depositAmount: "$100",
  },
  {
    id: "original",
    name: "Original Artwork Inquiry",
    detail: "Discuss an available original piece",
    deposit: "No deposit",
    depositAmount: null,
  },
  {
    id: "prints",
    name: "Prints & Products Inquiry",
    detail: "Editions, framing, and orders",
    deposit: "No deposit",
    depositAmount: null,
  },
];

export const MISSION_CHAPTERS = [
  {
    number: "01",
    title: "Sacred Vision & Purpose",
    content:
      "Art is never merely decorative. It is a language — one that can speak truth, invite peace, and reflect something of the majesty of the Creator into everyday spaces.",
  },
  {
    number: "02",
    title: "The Word Made Visible",
    content:
      "Every piece begins in scripture. Biblical themes, promises, and stories are woven into visual form so that the Word can be experienced through creativity, not only read.",
  },
  {
    number: "03",
    title: "Crafted with Devotion",
    content:
      "Meticulous detail, rich pigments, gold accents, and prayerful dedication characterize every piece that leaves the studio. Excellence is an act of worship.",
  },
  {
    number: "04",
    title: "Sent to Encourage",
    content:
      "Each artwork leaves the studio with one hope: that it would strengthen faith, spark conversation, and turn homes into quiet places of worship and remembrance.",
  },
];
